import './ServicesBottom.css';

function HelpIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" fill="#60a5fa" opacity="0.25" />
      <path
        d="M9.5 9.2a2.6 2.6 0 1 1 4.4 1.9c-.8.7-1.4 1.2-1.4 2.4"
        stroke="#ec4899"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="12.5" cy="16.8" r="1.1" fill="#ec4899" />
    </svg>
  );
}

function CraneIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M5 19h14" stroke="#16a34a" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M8 19V8l8-3v3" stroke="#eab308" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 8v11" stroke="#ef4444" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M16 11h4l-1.5 4H16" stroke="#ef4444" strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}

function BuildingIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M5 20V7l7-3 7 3v13" stroke="#6b7280" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M10 20v-5h4v5" stroke="#6b7280" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M9 9h1.5M13.5 9H15M9 12.5h1.5M13.5 12.5H15" stroke="#8b5cf6" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

const CARDS = [
  {
    title: 'Not Sure What You Need?',
    body: 'Our team can help you choose the right scrap collection service for your needs.',
    cta: 'Get Help →',
    href: '/contact',
    tone: 'blue',
    Icon: HelpIcon,
  },
  {
    title: 'Extra Large Project?',
    body: 'Need a large scrap clear-out beyond our standard jobs? We provide custom quotes.',
    cta: 'Get Custom Quote →',
    href: '/post-scrap',
    tone: 'green',
    Icon: CraneIcon,
  },
  {
    title: 'Business Account',
    body: 'Regular scrap collections? Open a business account for priority service.',
    cta: 'Open an Account →',
    href: '/become-a-collector',
    tone: 'purple',
    Icon: BuildingIcon,
  },
];

export default function ServicesBottom() {
  return (
    <section className="services-bottom" aria-label="Support options">
      <div className="services-bottom-inner">
        <div className="services-help-grid">
          {CARDS.map(({ title, body, cta, href, tone, Icon }) => (
            <article key={title} className="services-help-card">
              <span className={`services-help-icon tone-${tone}`}>
                <Icon />
              </span>
              <h3>{title}</h3>
              <p>{body}</p>
              <a className={`services-help-btn tone-${tone}`} href={href}>
                {cta}
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
